import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

function ComicCard({ comic, rank }: { comic: Comic; rank?: number }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group relative block overflow-hidden rounded-lg border border-background-800 bg-background-900/80 transition hover:border-primary-500/40 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} · ${comic.category}`}
          className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent"></div>

        {comic.isNew && (
          <span className="absolute left-2 top-2 rounded-full bg-accent-500 px-2 py-0.5 text-[10px] font-bold text-foreground-950">
            新作
          </span>
        )}

        <div className="absolute bottom-2 right-2 flex items-center gap-1 rounded-full bg-background-950/70 px-2 py-0.5 text-[11px] text-primary-300 backdrop-blur-sm">
          <i className="ri-fire-fill text-xs"></i>
          {comic.hotScore}热度
        </div>

        {rank !== undefined && (
          <span className="absolute left-2 top-2 flex h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 font-heading text-sm font-bold text-foreground-950">
            {rank}
          </span>
        )}
      </div>

      <div className="p-3 md:p-4">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-100 group-hover:text-primary-300 md:text-base">
          {comic.title}
        </h3>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span className="truncate">{comic.category}</span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line"></i>
            {comic.views}
          </span>
        </div>
      </div>
    </Link>
  );
}

export default ComicCard;